import React from 'react'

const ErrorField = ({message, className } : { message: string, className?: string }) => {
  return <p className={`text-error my-3 ${className}`}>{message}</p>
}

export default ErrorField
